import React, { useEffect, useState, useContext } from 'react'
import { useNavigate } from "react-router-dom";
import { DefaultContext } from '../../../context/context_default';

export const Card = ({ card, zoom, index, columMax }) => {
    const navigate = useNavigate()
    const {
        getSubTipos,
        subTipos,
        tipos,
        getTipos,
        getPalavrasChave,
        palavraChave,
        getFortunas,
        getCausas,
        causas,
        fortunas,
        getRaridade,
        raridades,
        listCards,
        getListCards,
        is_descktop,
        filterFetch,
        replaceText,
        HTMLRenderer

    } = useContext(DefaultContext);

    useEffect(() => {
        // getSubTipos();
        // getTipos();
        // getPalavrasChave();
        // getFortunas();
        // getCausas();
        // getRaridade();
        // getListCards();
        if (card.efeito.length < 100 && card.efeito.length > 0) {
            setEfeito(replaceText(card?.efeito))
        }


    }, [])

    const [imageLoaded, setImageLoaded] = useState(false);
    const [imagen, setImage] = useState(false);
    const [efeito, setEfeito] = useState(false);

    const [showOverlay, setshowOverlay] = useState(false);
    const hovering = () => setshowOverlay(true);
    const notHovering = () => setshowOverlay(false);

    const handleImageLoad = () => {
        setImageLoaded(true);
        // setImageLoaded(false);

    };
    const estiloDoComponenteCard = {
        WebkitFilter: 'drop-shadow(0px 0px 2px #0f0f0f95)',
        filter: 'drop-shadow(0px 0px 2px #0f0f0f)',
    };

    return (
        <div className={`${zoom ? "w-[235px] h-[335px]" : "w-[135px] h-[235px]"} m-[1px] relative  `} >

            <div className={`${zoom ? "hover:w-[241px] hover:h-[345px]" : "hover:w-[141px] hover:h-[245px] "} hover:translate-x-[-3px] hover:translate-y-[-5px] h-full w-full duration-100 cursor-pointer `} onMouseEnter={hovering} onMouseLeave={notHovering}>

                <img className=' w-full h-full object-contain' style={estiloDoComponenteCard} src={imageLoaded ? card?.url_img : require('../../../assets/imagens/back_card.png')} loading="lazy" onLoad={handleImageLoad}></img>
            </div>
            {!is_descktop ? null : <div className={`absolute  w-[200px] h-9 top-0 mt-4 ${(!zoom ? (index === columMax || index === columMax - 1) : (index === columMax)) ? "left-[-200px]" : "right-[-200px]"}  z-20 opacity-0 ${showOverlay ? "opacity-100 visible" : "invisible"} transition duration-300 flex flex-col space-y-2`}>
                <div className={`bg-slate-800 text-white shadow-md border-l-4 border-blue-500`}>
                    <div className='p-2 pb-0'>{card?.nome}</div>
                    <div className='p-2 pt-0 text-xs'>{card?.tipo?.map(e => tipos?.find(t => t?.id == e)?.tipo + ' ')} / {card?.sub_tipo?.map(e => subTipos?.find(t => t?.id == e)?.tipo + ' ')}</div>

                    {card?.custo || card?.poder || card?.vida ? <div className='border-b border-slate-700 '></div> : null}
                    {card?.custo ? <div className='p-2 pb-1 pt-1 flex justify-between items-center text-xs'><div>Custo:</div><div className='border-b border-slate-500 border-opacity-25 w-full mx-3'></div><div>{card?.custo}</div>  </div> : null}
                    {card?.p_a ? <div className='p-2 pb-0 pt-0 flex justify-between items-center text-xs'><div>Poder:</div><div className='border-b border-slate-500 border-opacity-25 w-full mx-3'></div><div>{card?.p_a}</div> </div> : null}
                    {card?.vida ? <div className='p-2 pb-1 pt-1 flex justify-between items-center text-xs'><div>Vida:</div><div className='border-b border-slate-500 border-opacity-25 w-full mx-3'></div><div>{card?.vida}</div> </div> : null}

                    {efeito ? <div className='border-b border-slate-700 '></div> : null}
                    {efeito ? <div className='p-2 text-xs'>
                        <div className='text-xs'>Efeito</div>
                        < HTMLRenderer html={efeito} />
                    </div> : null}
                    {card?.p_c.length > 0 ? <div className='border-b border-slate-700 '></div> : null}
                    {card?.p_c.length > 0 ? <div className='p-2 pb-1 pt-1 text-xs'>Palavras chave</div> : null}
                    {palavraChave && card ? card?.p_c?.map(id => { return <div className='p-2 pb-0 pt-0 text-xs flex justify-start items-center'><div className='rounded-full w-1 h-1 bg-slate-300 mr-2 ml-2 '></div><div>{palavraChave?.find(item => item.id == id)?.nome} </div></div> }) : null}
                    {card?.p_c.length > 0 ? <div className='p-2 pb-1 pt-1 text-xs'></div> : null}
                </div>



            </div>}

        </div >
    )
}
